<script setup>
import { onMounted, watch } from "vue";
import Chart from "chart.js/auto";

const props = defineProps({
  id: String,
  chartData: Object,
});

let chartInstance = null;

onMounted(() => {
  const ctx = document.getElementById(props.id)?.getContext("2d");
  if (!ctx) return;

  chartInstance = new Chart(ctx, {
    type: "pie",
    data: props.chartData,
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: "bottom",
          labels: {
            color: "#333",
          },
        },
      },
    },
  });
});

// Optional: Reactivity support for updated data
watch(
  () => props.chartData.datasets[0].data,
  () => {
    if (chartInstance) {
      chartInstance.data = props.chartData;
      chartInstance.update();
    }
  }
);
</script>

<template>
  <div class="card z-index-2">
    <div class="card-header">
      <h6 class="text-dark">Gateway vs Purchase Total</h6>
    </div>
    <div class="card-body">
      <canvas :id="props.id" height="300"></canvas>
    </div>
  </div>
</template>
